import { Data, Model, Validation } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../../App/Services/AppService';

export interface IExportDataApiClient {

    /** 
     * Fetches daily export data for the specified file grouping for the current UTC date and persists it to the Analytics database.
     * @param staticServiceProviderFileGroupingId The static service provider file grouping ID.
     * @returns A  representing the asynchronous operation.
     */
    executeDailySync(staticServiceProviderFileGroupingId: number): AxiosPromise<any>;

    // Client only properties / methods
}

@injectable()
export default class ExportDataApiClient extends Data.ApiClientBase implements IExportDataApiClient {

    constructor (config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/ExportData`);
    }

    public executeDailySync(staticServiceProviderFileGroupingId: number): AxiosPromise<any> {
        return this.axios.post(`${this.apiPath}/ExecuteDailySync?staticServiceProviderFileGroupingId=${staticServiceProviderFileGroupingId}`);
    }

    // Client only properties / methods
}